import { defineStore } from 'pinia'

import { useAuthorizationStore } from '@/store/authorizationStore'

import { ROUTER_PARAMS_NAMES } from '@/constants/routerParamsNames'

export const useRouterStore = defineStore('routerStore', {
    state: () => ({}),

    actions: {
        getParams(paramsNames) {
            if (!paramsNames && !Array.isArray(paramsNames)) {
                return {}
            }

            const authorizationStore = useAuthorizationStore()

            return paramsNames.reduce((params, name) => {
                if (name === ROUTER_PARAMS_NAMES.workspace) {
                    params[name] = authorizationStore.getWorkspaceSlug
                }

                if (name === ROUTER_PARAMS_NAMES.account) {
                    params[name] = authorizationStore.getAccountSlug
                }

                return params
            }, {})
        },
    },
})
